import { render, staticRenderFns } from "./ScrollableTable.vue?vue&type=template&id=e15adcda"
import script from "./ScrollableTable.vue?vue&type=script&lang=ts"
export * from "./ScrollableTable.vue?vue&type=script&lang=ts"
import style0 from "./ScrollableTable.vue?vue&type=style&index=0&id=e15adcda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports